import type { GlobalFilterField } from './GlobalFilterTypes';

/** Display metadata for the global-tier dimensions, incl. the group they sort under in the Add-filter menu. */
export interface GlobalFieldMeta {
    label: string;
    group: string;
}

export const GLOBAL_FIELD_META: Record<GlobalFilterField, GlobalFieldMeta> = {
    user_id: { label: 'Person', group: 'People' },
    provider_connection_id: { label: 'Provider', group: 'Providers' },
};

/** The global fields grouped by their menu section, preserving declaration order. */
export function globalFieldGroups(): { group: string; fields: GlobalFilterField[] }[] {
    const groups: { group: string; fields: GlobalFilterField[] }[] = [];
    for (const field of Object.keys(GLOBAL_FIELD_META) as GlobalFilterField[]) {
        const group = GLOBAL_FIELD_META[field].group;
        const existing = groups.find((entry) => entry.group === group);
        if (existing) existing.fields.push(field);
        else groups.push({ group, fields: [field] });
    }
    return groups;
}
